import GLOBAL from '../config/global';
import httpClient from '../utils/httpClient';

/**
 * Asks the Juice assistant a question.
 *
 * Goes through our own api, never directly to the RAG service: the service trusts a shared
 * proxy secret, and the caller's data scope is derived server-side from their user record.
 * The browser must hold neither. See octane_api/helpers/juiceScope.js.
 *
 * Adapted from the toolkit reference, which posts to a bare '/juiceAsk'. Every adapter in
 * this repository prefixes GLOBAL.API_URL, and without it the request goes to the FE's own
 * origin and 404s.
 *
 * @param {string} question
 * @param {string|null} conversationId  echoed back by the service; passing it lets a
 *   follow-up refine the previous question instead of starting over
 */
const ask = async (question, conversationId = null) => {
  const rtnObj = await httpClient.post(`${GLOBAL.API_URL}/juiceAsk`, {
    question,
    conversationId,
  });
  return rtnObj.data.message;
};

const JuiceAdapter = { ask };

export default JuiceAdapter;
